import { render } from "./PostulerView.vue?vue&type=template&id=6b710ac9&scoped=true"
import script from "./PostulerView.vue?vue&type=script&lang=js"
export * from "./PostulerView.vue?vue&type=script&lang=js"

import "./PostulerView.vue?vue&type=style&index=0&id=6b710ac9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b710ac9"]])

export default __exports__